import RequestsTable from "./components/RequestsTable"

export default function index() {
    return (
        <div className="mt-1 flex flex-col items-start">
            <RequestsTable />
        </div>
    )
}
